module.exports = __webpack_public_path__ + "img/21.a20af028.jpg";